import { Button } from './Button'

interface Props {
  onScheduleAssessment: () => void
}

const CAPABILITIES = [
  {
    title: 'Live migration with no downtime',
    body: 'For vMotion-class production workloads, source-to-CyCloud migration runs without service interruption.',
  },
  {
    title: 'Network extension preserves IP addresses',
    body: 'No re-IP, no firewall rule rewrites, no DNS updates post-migration. Workloads come up addressable on the same network they left.',
  },
  {
    title: 'Replication-assisted cutover',
    body: 'For large workloads where the migration window matters, replication runs in the background and cutover is a controlled switchover.',
  },
  {
    title: 'Source flexibility',
    body: 'VMware sources migrate natively. Non-VMware sources (Hyper-V, KVM, physical servers, hyperscaler VMs) migrate via guest-OS-level tooling.',
  },
]

export function Migration({ onScheduleAssessment }: Props) {
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <header className="max-w-3xl mb-10">
          <h2 className="text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
            Easy onboarding for workloads that fit.
          </h2>
          <p className="mt-3 text-base text-navy/70">
            CyCloud's platform includes mature workload mobility tooling for moving VMs
            from your existing environment.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {CAPABILITIES.map((c) => (
            <article
              key={c.title}
              className="bg-chalk border border-mist rounded-card p-6 shadow-card"
            >
              <h3 className="text-base font-semibold text-navy">{c.title}</h3>
              <p className="mt-2 text-sm text-navy/70 leading-relaxed">{c.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 p-6 bg-navy text-white rounded-card">
          <p className="text-sm leading-relaxed">
            Migration scoping happens during the architecture review — CyLogic's solutions
            team right-sizes the approach to your source environment and your migration
            window.
          </p>
          <div className="mt-4">
            <Button onClick={onScheduleAssessment} variant="primary">
              Schedule a migration assessment →
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
